<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('podcast-category')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">New Podcast Category</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <b-form-group label="Title">
          <base-input
            alternative
            class="mb-3"
            name="Title"
            :rules="{ required: true }"
            placeholder="Title"
            v-model="title"
            maxlength="200"
          >
          </base-input>
        </b-form-group>

        <!-- <base-input
          alternative
          class="mb-3 pt-3"
          name="Description"
          :rules="{ required: true }"
          placeholder="Description"
          v-model="body"
          maxlength="1000"
        >
        </base-input> -->
        <b-form-group label="Description">
          <quill-editor
            v-model="body"
            :options="editorOption"
            class="quill-h200px my-2"
          />
        </b-form-group>
        <!-- <el-select
          class="w-full rounded-lg mb-3"
          v-model="type"
          placeholder="Select type as a main banner or other small banners"
        >
          <el-option
            v-for="item in typeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->

        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 700 × 500px
        </div>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />

        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
        <img v-if="image" :src="image" ref="cover" />

        <div class="grid grid-cols-2 gap-4 mt-3">
          <div>
            <p class="mb-1">Meta Title</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaTitle"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Description</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaDesc"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Canonical Tag</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaCanonicalTag"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Keyword</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaKeyword"
            >
            </base-input>
          </div>
        </div>

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "./components/FileUploader.vue";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import _ from "lodash";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      title: "",
      image: null,
      coverImage: null,
      body: "",
      // type: "",
      buttonName: "",
      redirectTo: "",
      editorOption: {
        theme: "snow",
      },
      imageErr: false,
      typeOption: [
        {
          value: "main",
          label: "Main",
        },
        {
          value: "other",
          label: "Other",
        },
      ],
      msg: {},

      metaTitle: "",
      metaKeyword: "",
      metaDesc: "",
      metaCanonicalTag: "",
    };
  },

  methods: {
    handleSuccess(image) {
      console.log(image);

      this.imageErr = false;

      if (!image.type.startsWith("image/")) {
        this.$swal.fire({
          title: "Invalid File",
          text: "Please upload an image file only!",
          // html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          icon: "error",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          text: "Please ensure that the file size does not exceed 5MB",
          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      this.coverImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      if (!this.body) {
        this.$notify.error({
          message: "Description is required",
          position: "top-right",
        });
        return;
      }
      let FormData = require("form-data");
      let data = new FormData();
      data.append("name", this.title);
      data.append("image", this.coverImage);
      if (this.body) data.append("description", this.body);
      data.append("metaKeyword", this.metaKeyword);
      data.append("metaCanonicalTag", this.metaCanonicalTag);
      data.append("metaDesc", this.metaDesc);
      data.append("metaTitle", this.metaTitle);
      // data.append("type", this.type);
      //   data.append("redirectTo", this.redirectTo);
      //   data.append("buttonName", this.buttonName);
      let loader = this.$loading();
      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image or Upload SVG Image only",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      try {
        const blogdata = await this.$store.dispatch(
          "podcast/add_category",
          data
        );
        loader.close();
        if (blogdata.data.status == 202) {
          const errmsg = blogdata.data.message;
          this.$swal.fire({
            title: "INFO",
            text: errmsg || "Something went wrong",
            icon: "info",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
          });
        } else if (blogdata.code == 200) {
          this.$router.push({ name: "podcast-category" });
          this.$swal.fire({
            title: "Congratulations!",
            text: "Your podcast category successfully added",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      } catch (error) {
        console.log("error1", error);
      }
    },

    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
